<script lang="ts" setup>
import SubscribeCardBase from '@/views/search/SubscribeCardBase.vue';
import { useEditorialSubscriptionContext } from '@/views/editorial/useEditorialSubscriptionContext.ts';

const props = defineProps<{
  cityIds: number[];
  categoryIds: number[];
}>();

const { location, distance, status } = useEditorialSubscriptionContext(() => props.cityIds);
</script>

<template>
  <SubscribeCardBase :category-ids="categoryIds" :context-status="status" :distance="distance" :location="location" />
</template>

<style lang="css" scoped></style>
